// extracted by mini-css-extract-plugin
export default {"container":"FaqSection_container__aDmEs","faqSection":"FaqSection_faqSection__EG+-a","faqText":"FaqSection_faqText__kdl26","accordion":"FaqSection_accordion__F6w4+"};